import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Email } from "types";
import { Page } from "../Page";
import { EmailDetails } from "@/components/Email/EmailDetails";
import { EmailList } from "@/components/Email/EmailList";
import { EmailSearchBar } from "@/components/Email/EmailSearchBar";

export const EmailHistoryPage = () => {
    const history = useHistory();
    const [search, setSearch] = useState("");
    const [selectedEmail, setSelectedEmail] = useState<Email>();

    const handleSelectEmail = (email?: Email) => {
        history.push(`/emails/${email?.id ? email.id : ""}`);
        setSelectedEmail(email);
    };

    return (
        <Page className="ui-email-history-page" title="Email History">
            <div className="flex h-screen w-full flex-col overflow-hidden">
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Debug</Breadcrumb.Item>
                        <Breadcrumb.Item>Email History</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>

                    <EmailSearchBar onSearch={setSearch} />
                </HeaderToolbar>

                <div className="flex h-full flex-row divide-x divide-gray-light overflow-hidden">
                    <div className="w-50 flex-none lg:w-64 xl:w-75">
                        <EmailList search={search} selectedEmail={selectedEmail} onSelectEmail={handleSelectEmail} />
                    </div>
                    <div className="flex-1 overflow-auto">
                        <EmailDetails email={selectedEmail} />
                    </div>
                </div>
            </div>
        </Page>
    );
};
